import { type OutputLanguage } from '~/gql/graphql'

import { localeCodeMap } from './constants'

const getBrowserLocale = () => new Intl.Locale(window.navigator.language)

const normalizedBrowserLanguage = (language: string) => {
  if (language === 'en') {
    return localeCodeMap.enUs
  }

  return localeCodeMap.jaJp
}

export const getApplicationLocaleCode = () => {
  const browserLocale = getBrowserLocale()
  const language = browserLocale.language

  return normalizedBrowserLanguage(language)
}

// Maps the UI language (i18n.language, e.g. 'ja-JP' | 'en-US') to the GraphQL
// OutputLanguage value. Mirrors the backend prompt-builder's startsWith('ja')
// rule: anything Japanese -> JA, everything else -> EN.
export const toOutputLanguage = (language: string): OutputLanguage =>
  language.startsWith('ja') ? 'JA' : 'EN'
